import { Stack } from '@mui/material';
import { memo } from 'react';
import { teceoGrayPrimary, teceoGraySecondary } from '../../../../../../../../../../../../Theme';
import Typography from '../../../../../../../../../../../../components/Typography/Typography';
import LangEnum from '../../../../../../../../../../../../lang/LangEnum';
import { SelloutProductColor } from '../../../../../../../../../../../../services/modules/product-color-sellout/product-color-sellout.types';
import { useTranslation } from '../../../../../../../../../../../translation/TranslationContext';
import { useSelloutTableConfig } from '../../../../../hooks/useSelloutTableConfig';
import SelloutLeftColumnsRow from './SelloutLeftColumnsRow';

interface SelloutLeftColumnsDataRowsProps {
  selloutProductColor: SelloutProductColor;
}

const SelloutLeftColumnsDataRows = ({ selloutProductColor }: SelloutLeftColumnsDataRowsProps) => {
  const { translate } = useTranslation();
  const { tableRowsConfig } = useSelloutTableConfig({ selloutProductColor });

  return (
    <>
      <SelloutLeftColumnsRow
        height="40px"
        Value={
          <Typography noWrap color={teceoGraySecondary}>
            {translate(LangEnum.GLOBAL_TOTAL)}
          </Typography>
        }
      />

      {tableRowsConfig.map((config) => (
        <SelloutLeftColumnsRow
          key={config.titleKey}
          Value={
            <Typography color={teceoGrayPrimary} noWrap align="center">
              {config.total}
            </Typography>
          }
          Title={
            <Stack spacing="2px">
              <Typography color={teceoGrayPrimary} noWrap>
                {translate(config.titleKey)}
              </Typography>
              {config.subtitle && (
                <Typography color={teceoGrayPrimary} variant="body3-regular" noWrap>
                  {config.subtitle}
                </Typography>
              )}
            </Stack>
          }
        />
      ))}
    </>
  );
};

export default memo(SelloutLeftColumnsDataRows);
